import { render, staticRenderFns } from "./ProzessInput.vue?vue&type=template&id=6c4f73d0"
import script from "./ProzessInput.vue?vue&type=script&lang=js"
export * from "./ProzessInput.vue?vue&type=script&lang=js"
import style0 from "./ProzessInput.vue?vue&type=style&index=0&id=6c4f73d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports